import { ButtonLink } from "~/shared/components/ds/ButtonLink";
import {
  ErrorDisplayActions,
  ErrorDisplayContent,
  ErrorDisplayHeadline,
  ErrorDisplayLockup,
  ErrorDisplayLogo,
  ErrorDisplayMessage,
  ErrorDisplayRoot,
} from "~/shared/components/errors/ErrorDisplay";
import { CONTENT_LIBRARY_PATHS } from "~/team/constants/paths.constants";

export function ContentLibraryNotFound({ children }: { children: React.ReactNode }) {
  return (
    <ErrorDisplayRoot>
      <ErrorDisplayLogo />
      <ErrorDisplayContent>
        <ErrorDisplayLockup>
          <ErrorDisplayHeadline>Resource unavailable</ErrorDisplayHeadline>
          <ErrorDisplayMessage>
            The resource you&apos;re looking for isn't available. View all resources to find what you need, or try
            reloading the page.
          </ErrorDisplayMessage>
        </ErrorDisplayLockup>
        <ErrorDisplayActions>{children}</ErrorDisplayActions>
      </ErrorDisplayContent>
    </ErrorDisplayRoot>
  );
}

export function TeamContentLibraryNotFound() {
  return (
    <ContentLibraryNotFound>
      <ButtonLink variant="default" to={CONTENT_LIBRARY_PATHS.root}>
        View Resources
      </ButtonLink>
    </ContentLibraryNotFound>
  );
}
